export default __webpack_public_path__ + "static/media/teamsIcon.ff9e9a63.svg";